import PublicFooter from '../../components/footers/PublicFooter'
import MarketplaceHelmet from '../../seo/marketplace'
import StaticImage from './StaticImage'
import MarketplaceFilterBar from './marketplace/MarketplaceFilterBar'
import {
  getMarketplacePackages,
  getNextMarketplacePackages,
  getLocalMarketplacePackages,
  getNextLocalMarketplacePackages,
} from 'apiCalls/PackageRequests'
import publicNavbarLogo from 'assets/img/brand/logo.png'
import simpleLogo from 'assets/img/brand/simple-logo.png'
import axios from 'axios'
import { SpinLoader } from 'components/Loader/SpinLoader'
import { SpinLoaderFullScreen } from 'components/Loader/SpinLoaderFullScreen'
import CategoryModal from 'components/public/CategoryModal'
import MarketplaceCard from 'components/public/marketplace/MarketplaceCard'
import { useAppContext } from 'context/AppContext'
import React, { useEffect, useState, useRef } from 'react'
import { HiSearch } from 'react-icons/hi'
import { IoIosMenu } from 'react-icons/io'
import styled, { css } from 'styled-components'
import { getCategoryId, getPriorityPackageCategoriesKeys } from 'variables/functions'
import { packageCategories, urlCategories } from 'variables/general'
import { appEnvironment, googlePlacesKey } from 'configs'

function Marketplace(props) {
  const params = new URLSearchParams(window.location.search)
  document.body.style.overflow = 'visible'

  const [loaded, setLoaded] = useState(false)
  const [categoryOpen, setCategoryOpen] = useState(false)
  const [activeCategory, setActiveCategory] = useState(
    params.get('category') ? parseInt(getCategoryId(params.get('category'))) : 1,
  )
  const [GCLID] = useState(params.get('gclid') ? params.get('gclid') : '')
  const [, dispatch] = useAppContext()
  const source = axios.CancelToken.source()
  const [, setLocation] = useState({})
  const [locationValue, setLocationValue] = useState('')
  const [locationFilter, setLocationFilter] = useState(null)
  const [areaFilter, setAreaFilter] = useState(null)
  const [API, setAPI] = useState(null)
  const [packages, setPackages] = useState([])
  const [callComplete, setCallComplete] = useState(true)
  const [placeId, setPlaceId] = useState(params.get('city') ? params.get('city') : null)
  const [filterData, setFilterData] = useState({
    max_price: params.get('max-price') ? params.get('max-price') : '',
    min_price: params.get('min-price') ? params.get('min-price') : '',
    max_hours_of_coverage: params.get('max-hours-of-coverage') ? params.get('max-hours-of-coverage') : '',
    min_hours_of_coverage: params.get('min-hours-of-coverage') ? params.get('min-hours-of-coverage') : '',
    key_word: params.get('keyword') ? params.get('keyword') : '',
  })
  const [isNavCollapsed, setIsNavCollapsed] = useState(true)
  const [mobileScroll, setMobileScroll] = useState(0)
  const [mobilemodalopen, setMobilemodalopen] = useState(false)
  const [packagesExhausted, setPackagesExhausted] = useState(false)
  const [nextURL, setNextURL] = useState()
  const [localPackagesExhausted, setLocalPackagesExhausted] = useState(false)
  const [seed] = useState(Math.floor(Math.random() * 10000))
  const bodyRef = useRef()
  const [loadAllImages, setLoadAllImages] = useState(false)
  const [effectTrigger, setEffectTrigger] = useState(false)

  const handleNavCollapse = () => {
    setIsNavCollapsed(!isNavCollapsed)
  }

  useEffect(() => {
    setPackages([])
    setMobileScroll(0)
    setAreaFilter(null)
    setLoaded(false)
    setNextURL(null)
    setCallComplete(false)
    setPackagesExhausted(false)
    setLocalPackagesExhausted(false)
    if (params.get('city')) {
      if (!locationFilter) {
        setTimeout(() => {
          getLocationFromPlaceId(params.get('city'))
        }, 1000)
      } else {
        getPackages({
          nextPageURL: null,
          packagesExhausted: false,
          localPackagesExhausted: false,
          packages: [],
          loaded: false,
          filterData: filterData,
        })
      }
    } else {
      getPackages({
        nextPageURL: null,
        packagesExhausted: false,
        localPackagesExhausted: false,
        packages: [],
        loaded: false,
        filterData: filterData,
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationFilter, filterData, activeCategory, effectTrigger])

  const getLocationFromPlaceId = (placeId) => {
    if (typeof google === 'object') {
      let placeDetails = null
      const makeRequest = () => {
        // 2. Initialize the JavaScript client library.
        window.gapi.client
          .init({
            apiKey: googlePlacesKey,
          })
          .then(function () {
            const map = new google.maps.Map(document.getElementById('map'))
            /*global google*/
            const request = {
              placeId: placeId,
              fields: ['name', 'formatted_address', 'place_id', 'geometry'],
            }

            const service = new google.maps.places.PlacesService(map)

            service.getDetails(request, (place, status) => {
              if (status === 'OK') {
                let cityName = place.formatted_address.split(',')[2]
                  ? `${place.formatted_address.split(',')[0].trim()}-${place.formatted_address
                      .split(',')[2]
                      .trim()}`.toLowerCase()
                  : `${place.formatted_address.split(',')[0].trim()}-${place.formatted_address
                      .split(',')[1]
                      .trim()}`.toLowerCase()

                cityName = cityName.replace(' ', '-')

                placeDetails = {
                  latitude: place.geometry.location.lat().toFixed(4),
                  longitude: place.geometry.location.lng().toFixed(4),
                }

                setLocation(placeDetails)

                const locationParams = {
                  latitude: parseFloat(placeDetails.latitude),
                  longitude: parseFloat(placeDetails.longitude),
                  name: cityName,
                  place_id: place.place_id,
                }
                setLocationFilter(locationParams)

                if (!locationValue) {
                  setLocationValue(place.formatted_address)
                }
              }
            })

            // 3. Initialize and make the API request.
          })
      }

      window.gapi.load('client', makeRequest)
    } else {
      setTimeout(() => {
        setEffectTrigger(!effectTrigger)
      }, 500)
    }
  }

  // COMMENT

  // SETTING DYNAMIC URL BASED ON SEARCH PARAMS
  useEffect(() => {
    const params = new URLSearchParams()
    if (parseInt(activeCategory) !== 1) {
      params.append('category', urlCategories[activeCategory].name)
    }
    if (placeId) {
      params.append('city', placeId)
    }
    if (GCLID) {
      params.append('gclid', GCLID)
    }

    if (filterData.key_word) {
      params.append('keyword', filterData.key_word)
    }
    if (filterData.max_price) {
      params.append('max-price', filterData.max_price)
    }
    if (filterData.min_price) {
      params.append('min-price', filterData.min_price)
    }
    if (filterData.max_hours_of_coverage) {
      params.append('max-hours-of-coverage', filterData.max_hours_of_coverage)
    }
    if (filterData.min_hours_of_coverage) {
      params.append('min-hours-of-coverage', filterData.min_hours_of_coverage)
    }
    // if (filterData.date) {
    //   params.append('date', filterData.date)
    // }
    props.history.push({ search: params.toString() })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCategory, placeId, filterData])

  const getPackages = async ({
    nextPageURL,
    packagesExhausted,
    localPackagesExhausted,
    packages,
    loaded,
    filterData,
  }) => {
    let inputs = {}
    if (filterData.max_price) inputs.max_price = parseFloat(filterData.max_price)
    if (filterData.min_price) inputs.min_price = parseFloat(filterData.min_price)
    if (filterData.max_hours_of_coverage)
      inputs.max_hours_of_coverage = parseFloat(filterData.max_hours_of_coverage)
    if (filterData.min_hours_of_coverage)
      inputs.min_hours_of_coverage = parseFloat(filterData.min_hours_of_coverage)
    if (filterData.key_word) {
      inputs.keyword = filterData.key_word
    }

    if (!filterData.key_word) {
      if (activeCategory === 2) {
        // PASSING 1 AS TRUE AND 0 AS FALSE BECAUSE CANNOT PASS BOOLEAN VALUES IN URL
        inputs.featured = 1
      } else if (activeCategory > 2) {
        inputs.category = parseFloat(activeCategory)
      }
    }

    if (locationFilter) {
      inputs = {
        ...inputs,
        latitude: parseFloat(locationFilter.latitude),
        longitude: parseFloat(locationFilter.longitude),
      }
    }

    if (!localPackagesExhausted) {
      inputs = {
        ...inputs,
        limit: window.innerWidth > 700 ? 3 : 2,
        seed: seed,
      }
    }

    let response
    if (!localPackagesExhausted) {
      if (nextPageURL) {
        response = await getNextLocalMarketplacePackages(nextPageURL, source)
      } else {
        response = await getLocalMarketplacePackages(inputs, source)
      }
    } else if (!packagesExhausted) {
      if (nextPageURL) {
        response = await getNextMarketplacePackages(nextPageURL, source)
      } else {
        response = await getMarketplacePackages(inputs, source)
      }
    }

    if (response.status === 200) {
      if (!response.data.next) {
        if (!localPackagesExhausted && locationFilter) {
          setLocalPackagesExhausted(true)

          // CONTINUE SCROLLING PAGINATION AFTER LOCAL PACKAGES ARE EXHAUSTED
          getPackages({
            nextPageURL: null,
            packagesExhausted: packagesExhausted,
            localPackagesExhausted: true,
            packages: [...packages, ...response.data.results],
            loaded: false,
            filterData: filterData,
          })
        } else if (!packagesExhausted) {
          setPackagesExhausted(true)
        }
      }

      setPackages([...packages, ...response.data.results])
      setTimeout(() => {
        setCallComplete(true)
      }, 1000)

      if (!loaded) {
        setLoaded(true)
      }

      // FIX HTTPS BUG WHEN RUNNING ON DEV OR PRODUCTION
      if (response.data.next) {
        let nextPage =
          appEnvironment === 'production' || appEnvironment === 'development'
            ? response.data.next.replace('http', 'https')
            : response.data.next
        setNextURL(nextPage)
      } else {
        setNextURL(null)
        if (!localPackagesExhausted) {
          setLocalPackagesExhausted(true)
        }
      }
    } 
    // else {
    //   dispatch({
    //     type: 'setAlertType',
    //     alertType: 'error',
    //   })
    //   dispatch({
    //     type: 'setAlertText',
    //     alertText: [
    //       'We are currently undergoing unscheduled maintenance, we will be back up soon. Thank you for your patience',
    //     ],
    //   })
    //   throw new Error(response.data)
    // }
  }

  // LOCATION FINDER
  function handlePlaceSelect(autocomplete) {
    let place = autocomplete.getPlace()

    if (Object.keys(place).length > 1) {
      setLocationValue(place.formatted_address.substr(0, place.formatted_address.lastIndexOf(',')))
      setPlaceId(place.place_id)
      getLocationFromPlaceId(place.place_id)
    } else {
      dispatch({
        type: 'setAlertType',
        alertType: 'error',
      })
      dispatch({
        type: 'setAlertText',
        alertText: ['Please select a valid location'],
      })
    }
  }

  function handleChange(event) {
    event.persist()
    setLocationValue(event.target.value)
  }

  useEffect(() => {
    // DYNAMICALLY IMPORT GOOGLE MAPS API TO INCREASE LOAD SPEED
    import('../google_maps/autocomplete').then((module) => {
      setAPI(module)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // SCROLL FUNCTIONALITY USING KEYDOWN ON DESKTOP
  const keyDownHandler = (e) => {
    const elem = document.querySelector('#marketplace-side-container')

    elem.addEventListener('scroll', (e) => {
      if (e.detail === 'scrollDown') {
        elem.scrollTop = elem.scrollTop - 200
      }
      if (e.detail === 'scrollUp') {
        elem.scrollTop = elem.scrollTop + 200
      }
    })

    if (e.keyCode === 40) {
      elem.dispatchEvent(new CustomEvent('scroll', { detail: 'scrollUp' }))
    }
    if (e.keyCode === 38) {
      elem.dispatchEvent(new CustomEvent('scroll', { detail: 'scrollDown' }))
    }
  }
  document.onkeydown = keyDownHandler

  const handleScrollDesktop = (e) => {
    if (window.innerWidth > 1152) {
      const bottom = e.target.scrollHeight - e.target.scrollTop < e.target.clientHeight + 900
      if (nextURL && bottom && callComplete) {
        setCallComplete(false)
        getPackages({
          nextPageURL: nextURL,
          packagesExhausted: packagesExhausted,
          localPackagesExhausted: localPackagesExhausted,
          packages: packages,
          loaded: false,
          filterData: filterData,
        })
      }
    }
  }

  const handleScrollMobile = (e) => {
    if (!loadAllImages) {
      setLoadAllImages(true)
    }
    if (window.innerWidth < 600) {
      const bottom = e.target.scrollHeight - e.target.scrollTop < e.target.clientHeight + 3300
      if (nextURL && bottom && callComplete && mobileScroll !== 1) {
        setCallComplete(false)
        getPackages({
          nextPageURL: nextURL,
          packagesExhausted: packagesExhausted,
          localPackagesExhausted: localPackagesExhausted,
          packages: packages,
          loaded: false,
          filterData: filterData,
        })
      }
    } else if (window.innerWidth < 1152) {
      const bottom = e.target.scrollHeight - e.target.scrollTop < e.target.clientHeight + 1800
      if (nextURL && bottom && callComplete && mobileScroll !== 1) {
        setCallComplete(false)
        getPackages({
          nextPageURL: nextURL,
          packagesExhausted: packagesExhausted,
          localPackagesExhausted: localPackagesExhausted,
          packages: packages,
          loaded: false,
          filterData: filterData,
        })
      }
    }
  }

  function distance(lat1, lon1, lat2, lon2) {
    var p = 0.017453292519943295 // Math.PI / 180
    var c = Math.cos
    var a = 0.5 - c((lat2 - lat1) * p) / 2 + (c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))) / 2

    return 12742 * Math.asin(Math.sqrt(a)) // 2 * R; R = 6371 km
  }


  // MAKE FOOTER AVAIABLE TO CLICK AFTER 9 PAGES HAVE LOADED
  useEffect(() => {
    if (areaFilter === null && locationFilter && packages.length > 0) {
      const distanceFactor = distance(
        packages[0].location.latitude,
        packages[0].location.longitude,
        locationFilter.latitude,
        locationFilter.longitude,
      )
      setAreaFilter(distanceFactor)
    }

    if (nextURL && (nextURL.includes('offset=20') || nextURL.includes('page=5'))) {
      setMobileScroll(1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [packages])

  return (
    API && (
      <OuterContainer onScroll={handleScrollMobile} callComplete={callComplete}>
        <MarketplaceHelmet
          activeCategory={activeCategory}
          location={props.history.location}
          city={locationValue && locationValue.substr(0, locationValue.lastIndexOf(','))}
          keyword={filterData.key_word}
        />
        <NavBar id="marketplace-navbar" mobilemodalopen={mobilemodalopen} show={!isNavCollapsed}>
          {window.innerWidth < 900 ? null : (
            <NavbarBrand href="https://www.bookfocal.com/">
              <Img alt="public navbar logo" src={publicNavbarLogo} />
            </NavbarBrand>
          )}
          <InputWrapper>
            <Wrap1>
              {API && (
                <API.CitiesAutocomplete
                  id="city-autocomplete"
                  document={document}
                  handlePlaceSelect={handlePlaceSelect}
                />
              )}
              <FormWrap
                onSubmit={(e) => {
                  e.preventDefault()
                }}
                autoComplete="off"
                method="post"
              >
                <ImgLogo alt="public navbar logo" src={simpleLogo} />
                <Input
                  id="autocomplete"
                  type="text"
                  value={locationValue}
                  onChange={handleChange}
                  placeholder={'Enter a Location'}
                  autoComplete="false"
                />
              </FormWrap>
              <IconWrap>
                <SearchIcon />
              </IconWrap>
            </Wrap1>
          </InputWrapper>
          <BurgerButton id="navbar-collapse" onClick={handleNavCollapse}>
            <span>
              <ToggleIcon onClick={handleNavCollapse} />
            </span>
          </BurgerButton>
          <Menu $show={!isNavCollapsed}>
            <NavLinks>

              <H2 index={0} href={'https://www.bookfocal.com/how-it-works'} rel="noopener" target="_blank">
                How it Works
              </H2>
              <H2
                index={1}
                href={'https://www.bookfocal.com/about-the-focal-marketplace'}
                rel="noopener"
                target="_blank"
              >
                About
              </H2>
              <H2 index={2} href={'https://www.bookfocal.com/blogs/client'} rel="noopener" target="_blank">
                Blog
              </H2>
              <H2 index={3} href={'/auth/register'} rel="noopener" target="_blank">
                Join as a Photographer
              </H2>
            </NavLinks>
          </Menu>
        </NavBar>
        {window.innerWidth > 900 && (
          <FilterHeader>
            <MarketplaceFilterBar
              filterData={filterData}
              setFilterData={setFilterData}
              categoryOpen={categoryOpen}
              setCategoryOpen={setCategoryOpen}
              categoryName={packageCategories[activeCategory].name}
              active={activeCategory}
              setActive={setActiveCategory}
              categories={getPriorityPackageCategoriesKeys()}
              setPlaceId={setPlaceId}
              setLocationValue={setLocationValue}
              setLocation={setLocation}
              setAreaFilter={setAreaFilter}
              setLocationFilter={setLocationFilter}
              mobilemodalopen={mobilemodalopen}
              setMobilemodalopen={setMobilemodalopen}
            />
            {categoryOpen && (
              <CategoryModal
                active={activeCategory}
                setActive={setActiveCategory}
                categories={getPriorityPackageCategoriesKeys()}
                categoryOpen={categoryOpen}
                setCategoryOpen={setCategoryOpen}
                mobile={false}
              />
            )}
          </FilterHeader>
        )}
        {(!loaded || (locationFilter && areaFilter === null)) && !packagesExhausted ? (
          <SpinWrap>
            <SpinLoaderFullScreen />
          </SpinWrap>
        ) : (
          <Container
            id="marketplace-container"
            onClick={() => {
              if (categoryOpen) {
                setCategoryOpen(false)
              }
            }}
          >
            <Wrapper>
              <SubContainer
                id="marketplace-side-container"
                onScroll={handleScrollDesktop}
                callComplete={callComplete}
                length={packages.length}
                ref={bodyRef}
                onMouseEnter={() => !loadAllImages && setLoadAllImages(true)}
              >
                {!!packages.length && !filterData.key_word && (
                  <Row2 id="result-title">
                    {areaFilter <= 50 && (
                      <H1>
                        {parseInt(activeCategory) === 1
                          ? `Photography Packages `
                          : `${packageCategories[activeCategory].name} Photography Packages`}
                        {locationValue
                          ? ' in ' + locationValue.substr(0, locationValue.lastIndexOf(','))
                          : ''}
                      </H1>
                    )}
                    {areaFilter > 50 && (
                      <React.Fragment>
                        <H1>
                          {parseInt(activeCategory) === 1
                            ? `No Photography Packages `
                            : `No ${packageCategories[activeCategory].name} Photography Packages `}
                          {locationValue
                            ? ' found in ' + locationValue.substr(0, locationValue.lastIndexOf(','))
                            : ''}
                          .
                        </H1>
                        <H1>Here's the nearest options</H1>
                      </React.Fragment>
                    )}
                  </Row2>
                )}
                {!!packages.length && filterData.key_word && (
                  <Row2 id="result-title">
                    {areaFilter <= 50 && (
                      <H1>
                        {`Photography Packages containing "${filterData.key_word}" `}
                        {locationValue
                          ? ` found in ` + locationValue.substr(0, locationValue.lastIndexOf(','))
                          : ''}
                      </H1>
                    )}
                    {areaFilter > 50 && (
                      <React.Fragment>
                        <H1>
                          {`No Photography Packages containing "${filterData.key_word}" found in `}
                          {locationValue.substr(0, locationValue.lastIndexOf(','))}.
                        </H1>
                        <H1>Here's the nearest options</H1>
                      </React.Fragment>
                    )}
                  </Row2>
                )}
                {packages.map((pack, index) => {
                  return (
                    <GridCell key={pack.identifier} index={index}>
                      <MarketplaceCard
                        page="marketplace"
                        history={props.history}
                        items={pack.images}
                        package={pack}
                        loadAll={loadAllImages}
                      />
                    </GridCell>
                  )
                })}
                {
                  // EXTRA SPACE THROWN IN TO FIX NO SCROLL BUG AT %80 ZOOM
                  packages.length < 4 && packages.length > 2 && <GridCell1></GridCell1>
                }

                {packagesExhausted && packages.length === 0 && (
                  <TextWrap>
                    <H1> No Packages Found! </H1>
                  </TextWrap>
                )}
                {!callComplete && <SpinLoader />}
                {mobileScroll === 1 && nextURL && window.innerWidth < 1152 && (
                  <MoreResults onClick={() => setMobileScroll(2)}>
                    <H1>+ See More Results </H1>
                  </MoreResults>
                )}
              </SubContainer>
              {window.innerWidth > 1152 && <StaticImage cat={activeCategory} />}
            </Wrapper>
            {window.innerWidth < 900 && (
              <MobileFilterSection>
                <MarketplaceFilterBar
                  filterData={filterData}
                  setFilterData={setFilterData}
                  categoryOpen={categoryOpen}
                  setCategoryOpen={setCategoryOpen}
                  categoryName={packageCategories[activeCategory].name}
                  active={activeCategory}
                  setActive={setActiveCategory}
                  categories={getPriorityPackageCategoriesKeys()}
                  setPlaceId={setPlaceId}
                  setLocationValue={setLocationValue}
                  setLocation={setLocation}
                  setAreaFilter={setAreaFilter}
                  setLocationFilter={setLocationFilter}
                  mobilemodalopen={mobilemodalopen}
                  setMobilemodalopen={setMobilemodalopen}
                />{' '}
              </MobileFilterSection>
            )}
          </Container>
        )}
        <Map id="map"></Map>
        {(mobileScroll !== 2 || window.innerWidth > 1152 || !nextURL) && !mobilemodalopen && (
          <PublicFooter marketplace={true} />
        )}
        {!isNavCollapsed && (
          <ScreenDimmer
            onClick={() => {
              setIsNavCollapsed(true)
            }}
          ></ScreenDimmer>
        )}
      </OuterContainer>
    )
  )
}

export default Marketplace

Marketplace.propTypes = {}

const OuterContainer = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100vh;
  color: var(--black);
  overflow-y: ${(props) => (props.callComplete ? 'scroll' : 'hidden')};
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  ::-webkit-scrollbar {
    width: 0 !important;
  }
  @media (max-width: 1152px) {
    overflow-y: scroll;
  }
`

const Container = styled.div`
  position: relative;
  width: 100%;
  margin: 80px 0 0 0;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: center;
  font-size: 10px;
  z-index: 3;
  @media (max-width: 1400px) and (min-width: 1152px) {
    height: calc(100vh - 120px);
  }
  @media (max-width: 900px) {
    min-height: 100vh;
  }
  @media (max-width: 700px) {
    margin: 64px 0 0 0;
  }
`

const SubContainer = styled.div`
  position: relative;
  display: flex;
  flex: 0 0 auto;
  width: 59vw;
  padding: 90px 20px 30px 20px;
  flex-direction: column;
  overflow-y: scroll;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  height: calc(61.5vw - 36px);
  scroll-behavior: smooth;
  ::-webkit-scrollbar {
    width: 0 !important;
  }

  @media (max-width: 1400px) and (min-width: 1152px) {
    width: 62vw;
    height: calc(100vh - 120px);
  }

  @media (max-width: 1152px) {
    height: ${(props) => (props.length === 0 ? '40vh' : 'auto')};
    overflow-y: visible;
    font-size: 16px;
    width: 100%;
  }

  @media (max-width: 900px) {
    padding-top: 20px;
  }

  @media (max-width: 700px) {
    align-items: center;
    font-size: 13px;
    margin: 0;
    padding: 20px 0 0 0;
    background-color: #fff;
  }
`

const GridCell = styled.div`
  position: relative;
  border-top: 1px solid rgb(236, 239, 241);
  font-size: 9px;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  width: 100%;
  background: white;
  // border-radius: 16px;
  padding: 1.5em;
  margin: ${(props) => (props.index === 0 ? '0' : '3em 0 0 0')};

  @media (max-width: 1600px) {
    font-size: 8.5px;
  }
  @media (max-width: 800px) {
    font-size: 8px;
  }
  @media (max-width: 700px) {
    align-items: center;
    width: 100%;
    padding: 0 0 2em 0;
    border: none;
    border-radius: 0;
  }
  @media (max-width: 600px) {
    font-size: 7px;
  }
  @media (max-width: 500px) {
  }
`

const GridCell1 = styled(GridCell)`
  height: 320px;
`

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex: 0 0 auto;
  width: 100%;
  @media (max-width: 700px) {
    justify-content: center;
  }
`

const NavbarBrand = styled.a``

const MobileFilterSection = styled.div`
  width: fit-content;
  position: fixed;
  bottom: 20px;
  left: 0px;
  right: 0px;
  margin: 0 auto;
  z-index: 99;
  transition: bottom 300ms ease-in-out 0s;
`

const TextWrap = styled.div`
  position: relative;
  border: 1px solid rgb(236, 239, 241);
  font-size: 9px;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  width: 100%;
  background: white;
  border-radius: 16px;
  padding: 3em 1.5em;
  margin: 3em 0;
  font-size: 0.7em;
`

const Row2 = styled.div`
  position: relative;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  margin: 0.5em 0 1.6em 0;
  width: 100%;
  font-size: 10px;
  flex-wrap: wrap;
  @media (max-width: 700px) {
    padding: 0 30px;
    align-items: center;
    justify-content: center;
  }
  @media (max-width: 600px) {
    font-size: 9px;
  }
`

const H1 = styled.h1`
  font-weight: 550;
  font-size: 20px;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--black);
  word-break: break-word;
  width: 100%;
  @media (max-width: 700px) {
    font-size: 18px;
  }
  @media (max-width: 550px) {
    font-size: 16px;
  }
`

const SearchIcon = styled(HiSearch)`
  position: relative;
  color: #fff;
  font-size: 35px;
  padding: 8px;
  background: var(--forward);
  border-radius: 20px;
`

const InputWrapper = styled.div`
  position: relative;
  margin: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  cursor: pointer;
  border: 1.5px solid #dddddd;
  // border-radius: 40px;
  height: 50px;
  width: 18em;
  @media (max-width: 700px) {
    border: none;
  }
  @media (max-width: 900px) {
    width: 90%;
  }
`

const Input = styled.input`
  position: relative;
  height: 100%;
  width: 100%;
  font-size: 14px;
  border: none;
  padding: 5px;
  @media (max-width: 900px) {
    padding: 5px 5px 5px 8px;
  }
  @media (max-width: 700px) {
    padding: 5px 5px 5px 10px;
  }
  @media (max-width: 500px) {
    font-size: 13px;
  }
`

const FormWrap = styled.form`
  width: 100%;
  display: flex;
  align-items: center;
`

const Wrap1 = styled.div`
  position: absolute;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  left: 0;
  padding: 0 10px;
  width: 100%;
`
const IconWrap = styled.div`
  position: relative;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  @media (max-width: 700px) {
    display: none;
  }
`

const NavBar = styled.div`
  position: fixed;
  overflow: hidden;
  background: white;
  top: 0;
  left: 0;
  display: ${(props) => (props.mobilemodalopen ? 'none' : 'flex')};
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  padding: 0 2em;
  z-index: ${(props) => (props.show ? '6' : '4')};
  height: 80px;
  width: 100%;
  border-bottom: 1px solid #dddddd;
  @media (max-width: 900px) {
    padding: 0 20px;
  }
  @media (max-width: 700px) {
    height: 64px;
  }
  @media (max-width: 500px) {
    padding: 0 10px;
  }
`

const NavLinks = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  flex: 0 0 auto;
  justify-content: space-between;
  @media (max-width: 1152px) {
    flex-direction: column;
  }
`

const H2 = styled.a`
  position: relative;
  cursor: pointer;
  margin: 0 1em;
  font-size: 16px;
  font-weight: 400;
  :after {
    display: block;
    content: '';
    top: 10px;
    border-bottom: solid 2px var(--forward);
    transform: scaleX(0);
    transition: transform 250ms ease-in-out;
  }
  :hover:after {
    transform: scaleX(1);
  }

  @media (max-width: 1152px) {
    margin: 0;
    padding: 0.5em 1em;
    :after {
      display: none;
    }
    &:hover {
      background-color: var(--background-grey);
    }
  }
`
// const StyledNavLink = styled.a`
//   position: relative;
//   cursor: pointer;
//   margin: 0 0.7em;
//   font-size: 16px;
//   font-weight: 400;
//   :after {
//     display: block;
//     content: '';
//     top: 10px;
//     border-bottom: solid 2px var(--forward);
//     transform: scaleX(0);
//     transition: transform 250ms ease-in-out;
//   }
//   :hover:after {
//     transform: scaleX(1);
//   }
//   @media (max-width: 1152px) {
//     margin: 0;
//     padding: 0.5em 1em;
//     &:hover {
//       background-color: var(--background-grey);
//     }
//     :after {
//       display: none;
//     }
//   }
// `
const Img = styled.img`
  height: 25px;
`
const ImgLogo = styled.img`
  display: none;
  @media (max-width: 900px) {
    display: block;
    height: 25px;
    position: relative;
  }
`

const SpinWrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
`
const Map = styled.div`
  display: none;
`
const FilterHeader = styled.div`
  display: flex;
  flex: 0 0 auto;
  position: fixed;
  top: 80px;
  left: 0;
  padding: 20px 18px;
  width: 59vw;
  z-index: 4;
  background-color: white;
  border-bottom: 1px solid #dddddd;
  @media (max-width: 1400px) {
    width: 62vw;
  }
  @media (max-width: 1152px) {
    width: 100%;
  }
`

const Menu = styled.div`
  display: flex;
  flex: 0 0 auto;
  @media (max-width: 1152px) {
    display: none;
  }

  ${(props) =>
    props.$show &&
    css`
      @media (max-width: 1152px) {
        display: block;
        position: fixed;
        top: 60px;
        right: 2em;
        z-index: 999;
        padding: 1em 0;
        margin: 0;
        width: auto;
        height: auto;
        border-radius: 0.375rem;
        background: #fff;
        box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15),
          0 5px 15px rgba(0, 0, 0, 0.1);
        -webkit-animation: show-navbar-collapse 0.2s ease forwards;
        animation: show-navbar-collapse 0.2s ease forwards;
        opacity: 1;
        @media (max-width: 900px) {
          right: 20px;
          top: 50px;
        }
      }
    `}
`

const BurgerButton = styled.button`
  cursor: pointer;
  color: var(--dark-grey-2);
  border-color: transparent;
  font-size: 1.25rem;
  line-height: 1;
  background-color: initial;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  text-transform: none;
  overflow: visible;
  height: auto;
  &:focus {
    text-decoration: none;
  }
  &:hover {
    text-decoration: none;
  }
  @media (min-width: 1152px) {
    display: none;
  }
`

const ToggleIcon = styled(IoIosMenu)`
  width: 1.5em;
  height: 1.5em;
`
const MoreResults = styled.div`
  position: relative;
  border: 1px solid rgb(236, 239, 241);
  font-size: 9px;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  width: 100%;
  background: white;
  border-radius: 16px;
  padding: 3em 1.5em;
  margin: 3em 0;
  cursor: pointer;
`
const ScreenDimmer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: 4;
`
